import { Ambiente } from 'app/use-cases/orcamento/ambiente/Ambiente';
import React, { useEffect, useState } from 'react';



export type MenuDeAmbientesProps = {
    exibir: boolean,
    ambientes: Ambiente[],
    proximaCor: string
    onSalvarNovoAmbiente: (ambiente: Ambiente) => void
    onAmbienteSelecionado: (ambiente: Ambiente) => void
    onCancelar: () => void
    onAmbienteRemovido: (ambiente: Ambiente) => void
    toggleLimparNovoAmbiente: string
    onMouseSobreMenu?: (sobre: boolean) => void
}

const ItemMenu = ({ambiente, onSelecionado, onRemovido}: {
    ambiente: Ambiente, 
    onSelecionado: () => void,
    onRemovido: () => void}) => {
        return <div key={ambiente.nome} 
            className="_w-56 _flex _items-end"
            >

            <div className="_w-1/3">
                <IconeCirculoAmbiente cor={ambiente.cor}/>
            </div>

            <div className="_w-1/3 _cursor-pointer _justify-self-start"
                onClick={() => onSelecionado()}>{ambiente.nome}</div>

            <div className="_w-1/3 _cursor-pointer _text-right"
                onClick={() => onRemovido()}>
                X
            </div>

        </div>
}

const IconeCirculoAmbiente = ({cor}: {cor:string}) => {
    return <div className="_w-4 _h-4 _rounded-full"
        style={{
            backgroundColor: cor
        }}>

    </div>
}

export const MenuDeAmbientes = (props: MenuDeAmbientesProps) => {

    const [nomeNovoAmbiente, setNomeNovoAmbiente] = useState("")

    useEffect(() => {
        setNomeNovoAmbiente("")
    },[props.toggleLimparNovoAmbiente])

    return <>

        <div style={{
            display: props.exibir ? 'block' : 'none'
        }} className="_bg-white _p-4" id="bar"
            onMouseEnter={() => props.onMouseSobreMenu?.(true)}
            onMouseLeave={() => props.onMouseSobreMenu?.(false)}>
            <div className="_w-56 _flex _gap-2 _items-end">
                <div className="_w-1/3">
                    <IconeCirculoAmbiente cor={props.proximaCor}/>
                </div>

                <input className="_border-solid _border _w-48"
                    style={{
                        textAlign: 'left'
                    }}
                    value={(nomeNovoAmbiente) ?? ""}
                    onChange={e => setNomeNovoAmbiente(e.target.value)} />
            </div>

            {(props.ambientes ?? []).map(ambiente => <ItemMenu key={ambiente.nome} 
                ambiente={ambiente} 
                onSelecionado={() => props.onAmbienteSelecionado(ambiente)} 
                onRemovido={() => props.onAmbienteRemovido(ambiente)}/>)}

            <div className="_w-56 _flex _justify-between">
                <a className="_cursor-pointer"
                    onClick={() =>{
                        setNomeNovoAmbiente("")
                        props.onCancelar()
                    }}>Cancelar</a>

                <a className="_cursor-pointer"
                    onClick={() => props.onSalvarNovoAmbiente({ nome: nomeNovoAmbiente, cor: props.proximaCor } as Ambiente)}>Salvar</a>
            </div>
        </div>
    </>
}